export const PASSWORD_FORGOT_FETCH = 'password/FORGOT_PASSWORD_FETCH';
export const PASSWORD_FORGOT_SUCCESS = 'password/FORGOT_PASSWORD_SUCCESS';
export const PASSWORD_FORGOT_ERROR = 'password/FORGOT_PASSWORD_ERROR';

export const PASSWORD_CHANGE_FORGOT_PASSWORD_FETCH = 'password/CHANGE_FORGOT_PASSWORD_FETCH';
export const PASSWORD_CHANGE_FORGOT_PASSWORD_SUCCESS = 'password/CHANGE_FORGOT_PASSWORD_SUCCESS';
